import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Text } from '@mantine/core';
import axiosInstance from './../axiosInstance.js';

// The cycle a book belongs to ("Хрустальный путь": 1, 2, …), in reading
// order, with the book you are on marked. Books we have link to their
// pages; the rest link to the source so the reader can still find them.

const T = {
  ru: { cycle: 'Цикл', here: 'вы здесь', missing: 'нет в каталоге' },
  en: { cycle: 'Series', here: 'you are here', missing: 'not in the catalog' },
};

export default function BookSeries({ art, language }) {
  const t = T[language === 'en' ? 'en' : 'ru'];
  const [series, setSeries] = useState(null);

  useEffect(() => {
    if (!art || art.category !== 3) return undefined;
    let cancelled = false;
    let tries = 0;
    const load = () => {
      axiosInstance.get(`/arts/${art.id}/series`).then((r) => {
        if (cancelled) return;
        if (r.data.status === 'found') setSeries(r.data.series);
        // The worker is looking the book up right now; ask again shortly.
        else if (r.data.status === 'pending' && tries++ < 3) setTimeout(load, 4000);
      }).catch(() => {});
    };
    load();
    return () => { cancelled = true; };
  }, [art && art.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!series || !series.items || series.items.length < 2) return null;

  return (
    <div className="mt-4 mb-4">
      <Text size="sm" c="dimmed" fw={600} mb={6} ta="center">{t.cycle} «{series.name}»</Text>
      <div className="flex flex-col gap-1 mx-auto" style={{ maxWidth: 420 }}>
        {series.items.map((it) => {
          const here = it.artId === art.id;
          const name = (language !== 'en' && it.artRuName) || it.artName || it.title;
          const cover = it.thumbnailUrl || it.coverUrl;
          const inner = (
            <div className="flex items-center gap-3 py-1">
              <span className="text-xs w-5 text-right flex-shrink-0" style={{ color: 'var(--mantine-color-dimmed)' }}>{it.number}</span>
              {cover
                ? <img src={cover} alt="" width={28} height={40} style={{ objectFit: 'cover', borderRadius: 3, flexShrink: 0, background: 'var(--mantine-color-default-hover)' }} />
                : <span style={{ width: 28, height: 40, borderRadius: 3, flexShrink: 0, background: 'var(--mantine-color-default-hover)' }} />}
              <span className="min-w-0 truncate" style={{ fontWeight: here ? 600 : 400 }}>{name}</span>
              {here && <span className="text-xs flex-shrink-0" style={{ color: 'var(--mantine-color-dimmed)' }}>· {t.here}</span>}
              {!it.artId && <span className="text-xs flex-shrink-0" style={{ color: 'var(--mantine-color-dimmed)' }}>· {t.missing} ↗</span>}
            </div>
          );
          if (here) return <div key={it.sourceUrl}>{inner}</div>;
          if (it.artId) return <Link key={it.sourceUrl} to={`/arts/${it.artId}`} style={{ color: 'inherit', textDecoration: 'none' }}>{inner}</Link>;
          return <a key={it.sourceUrl} href={it.sourceUrl} target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{inner}</a>;
        })}
      </div>
    </div>
  );
}
